module.exports = __webpack_public_path__ + "aa8f25a2aada4f341877c84ac12ff940.jpg";